<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ns378V/tc-custom/9781497653689.jpg?1704831080607" alt="This image is the cover for the book Jasmine and the Jumping Pony, Pony Tails"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jasmine and the Jumping Pony, Pony Tails
      </h1>
      <p class="bookDescription body article font2">
        <b>Jasmine is great at riding ponies, but she’s about to learn that jumping can be especially challenging</b><br/><br/> Jasmine and her friends the Pony Tails are crazy about animals—especially ponies. This year, Jasmine and her pony Outlaw are taking their first jumping lesson at Pine Hollow Stables, and she couldn’t be more excited. All she can think about is jumping!<br/><br/> But during the lesson, Jasmine falls off Outlaw going over the very first jump. She is disappointed, embarrassed, and scared. Will Jasmine and Outlaw ever learn to jump like pros?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bonnie Bryant
      </h2>
      
      <p class="authorDescription body article">Bonnie Bryant is the author of over one hundred forty books about horses, including the Saddle Club series and its spinoffs, the Pony Tails series and the Pine Hollow series. Bryant did not know very much about horses before writing the first Saddle Club book in 1986, so she found herself learning right along with the characters she created. She has also written novels and movie novelizations under her married name, Bonnie Bryant Hiller. Bryant was born and raised in New York City, where she still lives today.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?53b4d7dc